import { Component, ElementRef, EventEmitter, HostListener, Injectable, Input, OnInit, Output, SimpleChange, ViewChild } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ContactService } from 'api-services/contact.service'
import { SharedService } from 'services';
import { State } from '../../../../models/state.model';
import { LinesOfAuthorityService } from 'api-services/lines-of-authority.service';
import { FinraUserLicenseService } from '../../../../api-services/finra-user-license.service';
import { FinraSeriesNumber } from '../../../../models/finra-user-license/finra-series-number.model';
import { FinraUserLicense } from '../../../../models/finra-user-license/finra-user-license.model';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { FinraUserLicenseDetail } from '../../../../models/finra-user-license/finra-user-license-detail.model';
import { forkJoin, Observable } from 'rxjs';
import { bottom } from '@popperjs/core';
import { Location } from '@angular/common';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.month + this.DELIMITER + date.day + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  selector: 'app-add-manual-license-finra',
  templateUrl: './add-manual-license-finra.component.html',
  styleUrls: ['./add-manual-license-finra.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ]
})
export class AddManualLicenseFinraComponent implements OnInit {

  isLicenseCreatedSuccessfully: boolean = false;
  @ViewChild('customDatePicker') customDatePickerEle: ElementRef;

  @Input() selectedFinraUserLicenseId;
  @Output() onCancel = new EventEmitter<void>();
  @Input() userId: number;

  userDetail: any;
  residentState: State;
  masterStates = [] as State[];
  today = new Date();

  minIssueDate: NgbDateStruct = { year: this.today.getFullYear() - 125, month: this.today.getMonth() + 1, day: this.today.getDate() }
  maxIssueDate: NgbDateStruct = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() }

  minExpDate: NgbDateStruct = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() }
  maxExpDate: NgbDateStruct = { year: this.today.getFullYear() + 10, month: this.today.getMonth() + 1, day: this.today.getDate() }

  finraSeriesNumberList = [] as FinraSeriesNumber[];
  finraUserLicenseForm!: FormGroup;
  selectedFinraSeriesName: string = '';
  selectedStateName: string = '';
  errorMessages = [];
  feinMask: any[] = [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  hide: boolean = false;
  show: boolean = true;
  @ViewChild('dropdownRef') dropdownRef: ElementRef;

  dropdownSettingSeries: IDropdownSettings;
  dropDownSettings = { label: "Series selection", multiple: true, column: 4, readOnly: false }

  selectedSeriesInfo = []
  unSelectedSeriesInfo = []
  selectedSeriesIds: any;
  editMode: boolean = false;
  isFromLicenseListPage: boolean = false;

  constructor(private fb: FormBuilder, private router: Router, private contactService: ContactService, private sharedService: SharedService
    , private loaService: LinesOfAuthorityService, private location: Location
    , private finraUserLicenseService: FinraUserLicenseService
  ) {
    if (localStorage.getItem('activeLicenseContactUserId') != null && localStorage.getItem('activeLicenseContactUserId').toString() != "") {
      this.userId = Number(localStorage.getItem("activeLicenseContactUserId"));
    }

    if (localStorage.getItem('selectedFinraUserLicenseId') != null && localStorage.getItem('selectedFinraUserLicenseId').toString() != "") {
      this.selectedFinraUserLicenseId = Number(localStorage.getItem("selectedFinraUserLicenseId"));
    }
    const nav = this.router.getCurrentNavigation();
    if (nav?.extras?.state && typeof nav.extras.state['isFromLicenseListPage'] === 'boolean') {
      this.isFromLicenseListPage = nav.extras.state['isFromLicenseListPage'];
    }
  }

  ngOnInit(): void {

    this.finraUserLicenseForm = this.fb.group({
      finraUserLicenseId: [],
      userId: [this.userId],
      tenantId: [],
      crdNumber: [null, [Validators.maxLength(25)]],
      stateId: [null, Validators.required],
      status: [null, Validators.required],
      securityRegistration: [null, Validators.required],
      issueDate: [null],
      expirationDate: [null],
      investmentAdvisor: [false],
      memo: [''],
      details: this.fb.array([], Validators.required)
    });

    this.dropdownSettingSeries = {
      singleSelection: false,
      idField: 'finraSeriesNumberId',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'Clear All'
    };

    forkJoin({
      masterStates: this.loaService.getAllStates(),
      userDetail: this.contactService.getUserInfo(this.userId),
      residentState: this.contactService.getResidenceStateOfUser(
        this.userId, this.sharedService.getValue("tenantId")
      ),
      finraSeriesNumberList: this.finraUserLicenseService.getFinraSeriesNumbers()
    }).subscribe({
      next: ({ masterStates, userDetail, residentState, finraSeriesNumberList }) => {
        this.masterStates = masterStates;
        this.userDetail = userDetail;
        this.residentState = residentState;

        this.finraSeriesNumberList = finraSeriesNumberList.map(item => ({
          ...item,
          isChecked: false
        }));
        this.setValue();

        if (this.selectedFinraUserLicenseId > 0) {
          this.getFinraUserLinceInfo();
        }

      },
      error: (err) => {
        console.error('Error fetching data:', err);
      }
    });

  }

  buildDetailForm(detail?: FinraUserLicenseDetail): FormGroup {
    return this.fb.group({
      finraUserLicenseDetailId: [detail?.finraUserLicenseDetailId || 0],
      finraUserLicenseId: [detail?.finraUserLicenseId || 0],
      finraSeriesNumberId: [detail?.finraSeriesNumberId || null, Validators.required],
      examPassDate: [this.setDateToNGBDatepickerFormat(detail?.examPassDate) || null],
      seriesName: [detail?.seriesName || ''],
      mmlisiApproveDate: [this.setDateToNGBDatepickerFormat(detail?.mmlisiApproveDate) || null],
      createdBy: [detail?.createdBy || null],
      updatedBy: [detail?.updatedBy || null],
      createdByName: [detail?.createdByName || ''],
      updatedByName: [detail?.updatedByName || ''],
      isEditable: [false]
    });

  }

  ngOnChanges(changes: SimpleChange) {
    this.setValue();
  }

  // getUser() {
  //   this.contactService.getUser(this.userId).subscribe((response: any) => {
  //     this.userDetail = response;
  //   },
  //     (error: any) => {
  //       console.log(error);
  //     })
  // }
  getUser() {
    this.contactService.getUserInfo(this.userId).subscribe((response: any) => {
      this.userDetail = response;
    },
      (error: any) => {
        console.log(error);
      })
  }

  getResidenceState() {
    return new Promise((resolve) => {
      this.contactService.getResidenceStateOfUser(this.userId, this.sharedService.getValue("tenantId")).subscribe(
        (response: any) => {
          this.residentState = response;
        },
        (error: any) => {
          console.log(error);
        }
      );
    });
  }

  getStates() {
    this.loaService.getAllStates().subscribe(
      response => {
        this.masterStates = response;
      },
      error => {

      }
    )
  }

  setDateToNGBDatepickerFormat(date) {
    if (date) {
      var fetchedDate = new Date(date);
      return {
        year: fetchedDate.getFullYear(),
        month: fetchedDate.getMonth() + 1,
        day: fetchedDate.getDate()
      };
    } else {
      return date;
    }

  }

  getFinraUserLinceInfo() {
    this.finraUserLicenseService.getFinraUserLicenseById(this.selectedFinraUserLicenseId).subscribe(
      response => {
        this.setFormValues(response);
      },
      error => {

      }
    )
  }

  setFormValues(data: FinraUserLicense) {

    this.finraUserLicenseForm.patchValue({
      finraUserLicenseId: data.finraUserLicenseId,
      userId: data.userId,
      stateId: data.stateId,
      status: data.status,
      crdNumber: data.crdNumber,
      investmentAdvisor: data.investmentAdvisor,
      issueDate: this.setDateToNGBDatepickerFormat(data.issueDate),
      expirationDate: this.setDateToNGBDatepickerFormat(data.expirationDate),
      examPassDate: data.details?.[0]?.examPassDate || null,
      approveDate: data.details?.[0]?.mmlisiApproveDate || null,
      memo: data.memo || null,
      securityRegistration: data.securityRegistration ?? false,
    });

    this.minExpDate = this.finraUserLicenseForm.value.issueDate ? this.finraUserLicenseForm.value.issueDate : this.minExpDate;
    
    const detailsArray = this.finraUserLicenseForm.get('details') as FormArray;
    detailsArray.clear();

    data.details?.forEach(detail => {
      const series = this.finraSeriesNumberList.find(obj => obj.finraSeriesNumberId == detail.finraSeriesNumberId);
      if (series) {
        series.isChecked = true;
      }
      const seriesName = series?.name || '';

      detail.seriesName = seriesName;
      detailsArray.push(this.buildDetailForm(detail));

    });


    if (data.details) {
      this.hide = true;
      this.show = false;
      this.getSelectedData();
    }

    if (localStorage.getItem('cloneForm') != null && localStorage.getItem('cloneForm').toString() != "") {
      this.cloneForm();
    }
    else {
      this.editMode = true;
    }

  }

  getFinraSeiesNumbers() {
    this.finraUserLicenseService.getFinraSeriesNumbers().subscribe(
      response => {
        this.finraSeriesNumberList = response;

        this.finraSeriesNumberList?.length > 0 ? this.setValue() : '';
      },
      error => {

      }
    )
  }

  setDate(event) {
    this.minExpDate = { year: event.year, month: event.month, day: event.day }

    if (this.finraUserLicenseForm?.value.expirationDate) {
      const zeroPad = (num, places) => String(num).padStart(places, '0');
      var todayDate = this.minExpDate.year.toString() + zeroPad(this.minExpDate.month.toString(), 2) + zeroPad(this.minExpDate.day.toString(), 2);
      var selExpDate = this.finraUserLicenseForm?.value.expirationDate.year.toString() + zeroPad(this.finraUserLicenseForm?.value.expirationDate.month.toString(), 2) + zeroPad(this.finraUserLicenseForm?.value.expirationDate.day.toString(), 2);

      Number(selExpDate) < Number(todayDate) ? this.finraUserLicenseForm.get('expirationDate')?.reset(null) : '';
    }
  }

  clearDate(clearControl) {
    this.finraUserLicenseForm.get(clearControl)?.reset(null);
    if (clearControl == 'issueDate') {
      this.minExpDate = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() }
      if (this.finraUserLicenseForm?.value.expirationDate) {
        const zeroPad = (num, places) => String(num).padStart(places, '0');
        var todayDate = this.minExpDate.year.toString() + zeroPad(this.minExpDate.month.toString(), 2) + zeroPad(this.minExpDate.day.toString(), 2);
        var selExpDate = this.finraUserLicenseForm?.value.expirationDate.year.toString() + zeroPad(this.finraUserLicenseForm?.value.expirationDate.month.toString(), 2) + zeroPad(this.finraUserLicenseForm?.value.expirationDate.day.toString(), 2);

        Number(selExpDate) < Number(todayDate) ? this.finraUserLicenseForm.get('expirationDate')?.reset(null) : '';
      }
    }
  }

  backToPage(viewMyLicense: boolean = false) {
    if (viewMyLicense)
    {
      this.router.navigate(['main-licenses'], { state: { tag: 'FINRA' } })
    }
    else if (this.isFromLicenseListPage || this.selectedFinraUserLicenseId > 0)
    {
      // this.router.navigate(['main-licenses'])
      this.location.back();
    }
    //else if(viewMyLicense){
    //  this.router.navigate(['main-licenses'], { state: { tag: 'FINRA' } }) 
    //}
    else {
      this.location.back();
     // this.router.navigate(['contact-list'])
    }

    
  }

  formatToDate(date: { year: number, month: number, day: number }): string {
    const yyyy = date.year.toString();
    const mm = date.month.toString().padStart(2, '0');
    const dd = date.day.toString().padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  convertDateFormat(date) {
    if (date) {
      var fetchedDate = new Date(date);
      return {
        year: fetchedDate.getFullYear(),
        month: fetchedDate.getMonth() + 1,
        day: fetchedDate.getDate()
      };
    } else {
      return null;
    }
  }

  createManualLicense() {
    this.isLicenseCreatedSuccessfully = false;

    (this.finraUserLicenseForm.get('details') as FormArray).clear();
    var defaultFormValues = {
      finraUserLicenseId: null,
      userId: this.userId,
      tenantId: null,
      crdNumber: null,
      stateId: null,
      status: null,
      securityRegistration: false,
      issueDate: null,
      expirationDate: null,
      investmentAdvisor: false,
      memo: '',
      details: []
    };

    this.finraUserLicenseForm.reset(defaultFormValues);

    
    this.finraSeriesNumberList.forEach(obj => obj.isChecked = false);
    this.getSelectedData();
  }

  addLicense() {
    if (this.finraUserLicenseForm.invalid) {
      this.finraUserLicenseForm.markAllAsTouched();
      return;
    }

    this.errorMessages = [];

    const formValue = this.finraUserLicenseForm.value;

    var finraUserLicense = {
      finraUserLicenseId: formValue.finraUserLicenseId,
      userId: formValue.userId,
      crdNumber: formValue.crdNumber,
      stateId: formValue.stateId,
      status: formValue.status || '', // set default if needed
      securityRegistration: formValue.securityRegistration || false,
      issueDate: formValue.issueDate != null ? this.formatToDate(formValue.issueDate) : undefined,
      expirationDate: formValue.expirationDate != null ? this.formatToDate(formValue.expirationDate) : undefined,
      investmentAdvisor: formValue.investmentAdvisor,
      memo: formValue.memo || '',
      details: formValue.details.map((d: any): FinraUserLicenseDetail => ({
        finraUserLicenseDetailId: d.finraUserLicenseDetailId,
        finraUserLicenseId: d.finraUserLicenseId,
        finraSeriesNumberId: d.finraSeriesNumberId,
        examPassDate: d.examPassDate != null ? this.formatToDate(d.examPassDate) : undefined,
        mmlisiApproveDate: d.mmlisiApproveDate != null ? this.formatToDate(d.mmlisiApproveDate) : undefined,
      }))
    } as FinraUserLicense;

    this.finraUserLicenseService.insertFinraUserLicense(finraUserLicense).subscribe(
      (response: any) => {
        if (response > 0) {
          this.isLicenseCreatedSuccessfully = true;
        }
      },
      (error: any) => {
        if (error != null && error.message != null) {
          this.errorMessages.push(error.message);
        }
        else {
          this.errorMessages.push("Error communicating with the server.  If this error persists, contact support.");
        }
      }
    );
  }

  updateLicense() {
    this.errorMessages = [];

    const formValue = this.finraUserLicenseForm.value;

    var finraUserLicense = {
      finraUserLicenseId: formValue.finraUserLicenseId,
      userId: formValue.userId,
      crdNumber: formValue.crdNumber,
      stateId: formValue.stateId,
      status: formValue.status || '', // set default if needed
      securityRegistration: formValue.securityRegistration || false,
      issueDate: formValue.issueDate != null ? this.formatToDate(formValue.issueDate) : undefined,
      expirationDate: formValue.expirationDate != null ? this.formatToDate(formValue.expirationDate) : undefined,
      investmentAdvisor: formValue.investmentAdvisor,
      memo: formValue.memo || '',
      details: formValue.details.map((d: any): FinraUserLicenseDetail => ({
        finraUserLicenseDetailId: d.finraUserLicenseDetailId,
        finraUserLicenseId: d.finraUserLicenseId,
        finraSeriesNumberId: d.finraSeriesNumberId,
        examPassDate: d.examPassDate != null ? this.formatToDate(d.examPassDate) : undefined,
        mmlisiApproveDate: d.mmlisiApproveDate != null ? this.formatToDate(d.mmlisiApproveDate) : undefined,
      }))
    } as FinraUserLicense;

    this.finraUserLicenseService.updateFinraUserLicense(finraUserLicense).subscribe(
      (response: any) => {
        this.sharedService.showToastMessage("License updated successfully.");
      },
      (error: any) => {
        if (error != null && error.message != null) {
          this.errorMessages.push(error.message);
        }
        else {
          this.errorMessages.push("Error communicating with the server.  If this error persists, contact support.");
        }
      }
    );
  }

  onStateChange(stateId: any) {
    const selectedState = this.masterStates.find(state => state.stateId === stateId);
    if (selectedState) {
      this.selectedStateName = selectedState.stateName;
    }
  }

  onFinraSeriesNameChange(finraSeriesNameId: any) {
    const selectedObj = this.finraSeriesNumberList.find(obj => obj.finraSeriesNumberId === finraSeriesNameId);
    if (selectedObj) {
      this.selectedFinraSeriesName = selectedObj.name;
    }
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event) {
    if (this.dropdownRef && !this.dropdownRef.nativeElement.contains(event.target)
    ) {
      this.hide = false;
      this.show = true;
    }
  }

  addSeries(event) {
    event.stopPropagation();
    this.hide = true;
    this.show = false;
  }

  hideSeries(event) {
    this.hide = false;
    this.show = true;
  }

  setValue() {
    this.finraSeriesNumberList = this.finraSeriesNumberList?.map(m => ({ ...m, isChecked: false }));
    if (this.selectedSeriesIds?.length > 0) {
      const stateIdsArray: number[] = this.selectedSeriesIds?.split(',').map(id => parseInt(id.trim(), 10));

      stateIdsArray.forEach(id => {
        const foundState = this.finraSeriesNumberList.find(series => series.finraSeriesNumberId === id);
        if (foundState) {
          foundState['isChecked'] = true;
          this.selectedSeriesInfo.push(foundState);
        }
      });
    }
    else {
      this.finraSeriesNumberList.forEach(obj => obj.isChecked == false);
    }
    this.getSelectedData();
  }

  onSelectionChange(id: number) {
    this.finraSeriesNumberList.forEach(x => {
      var _continue: boolean = true;
      var finraUserLicense = this.finraUserLicenseForm.value;
      if (finraUserLicense.details != null) {
        var details = finraUserLicense.details as FinraUserLicenseDetail[];

        if (details.find(obj => obj.finraSeriesNumberId == x.finraSeriesNumberId && obj.finraUserLicenseDetailId > 0) != null) {
          _continue = false;
        }
      }

      if (_continue) {
        if (x.finraSeriesNumberId === id) {
          x.isChecked = !x.isChecked;

          if (x.isChecked) {
            this.addDetail(x.finraSeriesNumberId, x.name);
          } else {
            this.removeDetailBySeriesId(x.finraSeriesNumberId);
          }
        } else if (id === 0) {
          x.isChecked = this.selectedSeriesInfo?.length === this.finraSeriesNumberList?.length ? false : true;
          if (x.isChecked) {
            this.addDetail(x.finraSeriesNumberId, x.name);
          } else {
            this.removeDetailBySeriesId(x.finraSeriesNumberId);
          }
        }
      }
    });
    this.getSelectedData();
  }

  addDetail(seriesId: number, seriesName: string) {
    const detailsArray = this.finraUserLicenseForm.get('details') as FormArray;

    const exists = detailsArray.controls.some(
      control => control.get('finraSeriesNumberId')?.value === seriesId
    );

    if (!exists) {
      var obj = {
        finraSeriesNumberId: seriesId,
        seriesName: seriesName
      } as FinraUserLicenseDetail;
      detailsArray.push(this.buildDetailForm(obj));
    }
  }

  removeDetailBySeriesId(seriesId: number) {
    const detailsArray = this.finraUserLicenseForm.get('details') as FormArray;

    const index = detailsArray.controls.findIndex(
      control => control.get('finraSeriesNumberId')?.value === seriesId
    );

    if (index !== -1) {
      detailsArray.removeAt(index);
    }
  }

  getSelectedData() {
    this.unSelectedSeriesInfo = this.finraSeriesNumberList.filter(x => x.isChecked === false);
    this.selectedSeriesInfo = this.finraSeriesNumberList.filter(x => x.isChecked === true);
  }

  deleteFinraUserDetail(finraUserLicenseDetailId?: number, finraSeriesNumberId?: number) {
    if (!this.editMode && finraSeriesNumberId > 0) {
      var detail = this.finraSeriesNumberList.find(obj => obj.finraSeriesNumberId == finraSeriesNumberId);
      if (detail) {
        detail.isChecked = false;
      }
      this.removeDetailBySeriesId(finraSeriesNumberId);
      this.getSelectedData();
    }
    else if (this.editMode && finraUserLicenseDetailId > 0) {
      this.finraUserLicenseService.deleteFinraUserLicenseDetail(finraUserLicenseDetailId).subscribe(
        response => {
          if (response > 0) {
            var detail = this.finraSeriesNumberList.find(obj => obj.finraSeriesNumberId == finraSeriesNumberId);
            if (detail) {
              detail.isChecked = false;
            }
            this.removeDetailBySeriesId(finraSeriesNumberId);
            this.getSelectedData();
            this.sharedService.showToastMessage("Series deleted successfully.");
          }
        },
        error => {

        })
    }
    else {
      var detail = this.finraSeriesNumberList.find(obj => obj.finraSeriesNumberId == finraSeriesNumberId);
      if (detail) {
        detail.isChecked = false;
      }
      this.removeDetailBySeriesId(finraSeriesNumberId);
      this.getSelectedData();
    }
  }

  updateDetailItem(detail) {
    var _finraUserLincenseDetail = detail.value;
    _finraUserLincenseDetail.examPassDate = _finraUserLincenseDetail.examPassDate != null ? this.formatToDate(_finraUserLincenseDetail.examPassDate) : undefined;
    _finraUserLincenseDetail.mmlisiApproveDate = _finraUserLincenseDetail.mmlisiApproveDate != null ? this.formatToDate(_finraUserLincenseDetail.mmlisiApproveDate) : undefined;

    if (_finraUserLincenseDetail.finraUserLicenseDetailId > 0) {
      this.finraUserLicenseService.updateFinraUserLicenseDetail(_finraUserLincenseDetail).subscribe(
        (response: any) => {
          this.sharedService.showToastMessage("Series updated successfully.");
          this.closeEditable(detail);
        },
        (error: any) => {
          if (error != null && error.message != null) {
            this.errorMessages.push(error.message);
          }
          else {
            this.errorMessages.push("Error communicating with the server.  If this error persists, contact support.");
          }
        }
      );
    }
    else {
      _finraUserLincenseDetail.finraUserLicenseId = this.finraUserLicenseForm.get("finraUserLicenseId").value;
      this.finraUserLicenseService.insertFinraUserLicenseDetail(_finraUserLincenseDetail).subscribe(
        (response: any) => {
          this.sharedService.showToastMessage("Series added successfully.");
          detail.get('finraUserLicenseDetailId')?.setValue(response)
          this.closeEditable(detail);
        },
        (error: any) => {
          if (error != null && error.message != null) {
            this.errorMessages.push(error.message);
          }
          else {
            this.errorMessages.push("Error communicating with the server.  If this error persists, contact support.");
          }
        }
      );

    }
  }

  closeEditable(detail) {
    detail.get('isEditable')?.setValue(false);
  }

  editDetailItem(detail) {
    detail.get('isEditable')?.setValue(true);
  }

  getSeriesNames(details: FinraUserLicenseDetail[]): string {
    return details.map(d => d.seriesName).filter(Boolean).join(', ');
  }

  cloneForm() {
    localStorage.removeItem('selectedFinraUserLicenseId');
    this.isLicenseCreatedSuccessfully = false;
    this.editMode = false;
    this.finraUserLicenseForm.patchValue({
      finraUserLicenseId: null,
      stateId: null
    });

    const detailsArray = this.finraUserLicenseForm.get('details') as FormArray;

    detailsArray.controls.forEach((control: AbstractControl) => {
      control.patchValue({
        finraUserLicenseDetailId: null,
        finraUserLicenseId: null,
        isEditable: false
      });
    });

    this.sharedService.showToastMessage("License copied successfully.");
  }

  canDelete(): boolean {
    const details = this.finraUserLicenseForm.get('details')?.value || [];
    const validCount = details.filter((d: any) => d.finraUserLicenseDetailId > 0).length;

    return !this.editMode || validCount > 1;
  }

}
